import type { RoomsParticipantDistribution } from '@/domain/shared/types'

export interface Option {
  name: string
  value: string
  resultsCount?: string
  groupInfo?: string
  selected?: boolean
}
export interface FiltersResponse {
  DepartureAirport: MultiSelectPricesFilter
  Duration: MultiSelectPricesFilter
  Mealplan: MultiSelectPricesFilter
  Month: MultiSelectPricesFilter
  TransportType: MultiSelectPricesFilter
  RoomType: MultiSelectPricesFilter
  Participants: RoomsParticipantDistribution
}

export interface MultiSelectPricesFilter {
  options: Option[]
}

export interface Option {
  name: string
  value: string
  resultsCount?: string
  groupInfo?: string
  selected?: boolean
}

export type FilterSelection = MultiSelectFilters & SelectFilters & ParticipantsFilter & DepartureDateFilter

export interface MultiSelectFilters {
  DepartureAirport?: string[]
  Duration?: string[]
  RoomType?: string[]
}

export const SingleSelectFiltersKeys = [
  'Mealplan',
  'Month',
  'TransportType',
  'DateFrom',
  'DateTo',
] as (keyof SelectFilters)[]

export interface SelectFilters {
  Mealplan?: string
  Month?: string
  TransportType?: string
  DateFrom?: string
  DateTo?: string
}

export interface ParticipantsFilter {
  Participants?: RoomsParticipantDistribution
}

export interface DepartureDateFilter {
  DepartureDate?: string[]
}

export interface FiltersInPrices extends MultiSelectFilters, SelectFilters, ParticipantsFilter, DepartureDateFilter {}

export type MultiselectFilterType = keyof MultiSelectFilters
export type SelectFilterType = keyof SelectFilters
export type FilterType = MultiselectFilterType & SelectFilterType

export type PricesFilterType = keyof FiltersInPrices

export type FiltersInPricesValues = FiltersInPrices[PricesFilterType]
